import React, { useMemo } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { useTenant } from '../core/hooks/useTenant';
import TenantAccessGate from '../core/components/TenantAccessGate';
import { getRoutesByStoreType } from './getRoutesByStoreType';

const TenantModuleRouter = () => {
  const { storeType } = useTenant();
  const { routes, defaultPath } = getRoutesByStoreType(storeType);

  const routeObjects = useMemo(() => {
    const dynamicRoutes = routes.map((route) => {
      const wrapped = (
        <TenantAccessGate permission={route.permission} moduleKey={route.moduleKey}>
          {route.element}
        </TenantAccessGate>
      );

      return {
        path: route.path,
        element: wrapped,
      };
    });

    return [
      ...dynamicRoutes,
      { path: '/', element: <Navigate to={defaultPath} replace /> },
      { path: '*', element: <Navigate to={defaultPath} replace /> },
    ];
  }, [routes, defaultPath]);

  return useRoutes(routeObjects);
};

export default TenantModuleRouter;
